import { defineMessages } from "react-intl";

const scope = "supportui.components.AgreementsPage";

export default defineMessages({
  createAgreement: {
    id: `${scope}.createAgreement`,
    defaultMessage: "Create",
  },
  unableToCreateAgreement: {
    id: `${scope}.unableToCreateAgreement`,
    defaultMessage: "unable to create supplier agreement:",
  },
  agreementConflict: {
    id: `${scope}.agreementConflict`,
    defaultMessage:
      "supplier agreement already exists for this supplier and card issuer",
  },
  agreementsSaved: {
    id: `${scope}.agreementsSaved`,
    defaultMessage:
      "{totalCount} agreement changes have been successfully saved",
  },
  agreementsImportComplete: {
    id: `${scope}.agreementsImportComplete`,
    defaultMessage: "Complete",
  },
  cancelAgreementsImport: {
    id: `${scope}.cancelAgreementsImport`,
    defaultMessage: "Cancel import",
  },
  savingAgreements: {
    id: `${scope}.savingAgreements`,
    defaultMessage: "Saving agreements...",
  },
  uploadingAgreements: {
    id: `${scope}.uploadingAgreements`,
    defaultMessage: "Importing agreements...",
  },
  agreementsToBeSaved: {
    id: `${scope}.agreementsToBeSaved`,
    defaultMessage: "Agreement changes to be saved",
  },
  agreementsValidCount: {
    id: `${scope}.agreementsValidCount`,
    defaultMessage: "Found {totalCount} valid agreement changes",
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: "Save",
  },
  agreementsUploadFailed: {
    id: `${scope}.agreementsUploadFailed`,
    defaultMessage: "Agreements import failed",
  },
  returnToStations: {
    id: `${scope}.returnToStations`,
    defaultMessage: "Return to stations",
  },
  errors: {
    id: `${scope}.errors`,
    defaultMessage: "Errors",
  },
  chooseOperation: {
    id: `${scope}.Choose operation`,
    defaultMessage: "Agreement actions:",
  },
});
